import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EventService from '../../services/EventService';
import moment from "moment";
import CountryHeader from "./CountryHeader";
import { showLoading } from 'react-global-loading';

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const CountryEvents = (props) => {
  const [countryId, setCountryId] = useState(props.match.params.id);
  const [categoryId, setCategoryId] = useState(props.match.params.catId);
  const [eventsList, setEventsList] = useState([]);

  useEffect(() => {
    showLoading(true);
    getEventList();
  }, []);

  const getEventList = () => {
    EventService.getAllEventByCountry({ 'blog_id': countryId, 'category': categoryId })
      .then((result) => {
        if (!result) {
          return;
        }
        setEventsList(result);
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleCallback = (childData) => {

    setCategoryId(childData.id)
  };
  return (
    <div className="container pt-2">
      <CountryHeader parentCallback={handleCallback} category={categoryId} country={countryId} />
      <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <h3 className="mb-3">Events</h3>
          <div className="row view-group" id="Events2">
            {/* below is the Event card */}
            {(eventsList.length > 0) ? eventsList.map((item, index) =>
              <div key={index} className="col-md-3 mb-3">
                <Link to={{
                  pathname: "/country-event-details",
                  search: `?id=${item.ID}`,
                  state: { EventDetails: item }
                }}>
                  <div className="card p-3 event-card crdev">
                    <div className="imgrel">

                      <img src={item.image_upload} className="card-img-top rounded" style={{ height: '150px', objectFit: 'cover' }} />

                    </div>
                    <div className="evtxcn px-0">
                      <h4 className="evh">
                        <span className="evhd crop-text-title">{item.post_title}</span>
                      </h4>
                      {/* <span className="muted d-block mt-1 doccell crop-text">{item.post_title}</span> */}

                      <p className="evdes_nw crop-text">{item.post_content}</p>
                    </div>
                  </div>
                </Link>
                <div className="crbotm">
                  <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                  <span className="dtpr">/</span>
                  <p className="dtpr">{` Last Updated On - `}<span className="cdte">{moment(item.post_modified).format("Do MMM YYYY")}</span></p>
                </div>
              </div>
            ) : <div className="col-12 mb-4">
              <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">
                  <i class="fa fa-exclamation-circle me-1" aria-hidden="true"></i> Data Not Found!
                </h4>
                <p>We regret to inform you that the requested data could not be located or does not exist in our records. It is possible that the information you are seeking has not been documented, is not publicly available, or has been removed or archived.</p>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryEvents;
